export type ModelMapValueType = {
    ccName: string;
    id: string;
    internalCode: string;
    localCode: string;
    name: string;
    isNewGeneration: boolean;
    token?: string;
    links?: {
        modelPage?: string;
        carGrade?: string;
        buildPage?: string;
    };
    subModels?: {
        id: string;
        internalCode: string;
        localCode: string;
        name: string;
        hybrid: boolean;
    }[];
};

export type MonthlyRateCalculationLabelType = {
    key: string;
    label: string;
    tooltip?: string;
    showIfZero: boolean;
};

export enum ServiceTypeEnum {
    Tradein = "tradein",
    Finance = "finance",
    Insurance = "insurance",
    Serviceplans = "serviceplans",
    Banner = "banner",
    Financepacks = "financepacks",
}

export type ServiceType = {
    type: ServiceTypeEnum;
    title?: string;
    description?: string;
    bannerLinkImage?: string; // Shown in Tridion as bannerImage, has nothing to do with the "banner" type
    bannerLinkLabel?: string; // optional link text
    bannerLinkUrl?: string; // optional link href
};

export type PublicChargingType = {
    type: "public";
    title?: string;
    publicChargingAbout?: string;
    publicChargingAboutUrl?: string;
    publicChargingTitle?: string;
    publicChargingFeatures: string[];
    bannerLinkImage?: string;
    homeChargingAbout?: string;
};

export type HomeChargingType = {
    type: "home";
    title?: string;
    homeChargingLearnMore?: string;
    homeChargingUrl?: string;
    homeChargingTimeAndRangeUrl?: string;
};

export type ChargingType = PublicChargingType | HomeChargingType;

export type AemEcoLabelSettingsType = { images: Record<string, string> };

export type EcoLabelSettingsType = {
    // TDE eco image
    title?: string;
    intro?: string;
    disclaimer?: string;
    configuredTitle?: string;
    label?: string;
    images?: Record<string, string>; // contains url to image for every efficiencyClass value
    // TES eco badge
    energyEfficiencyClassName?: string; // not used, GFI needs this for cocadap only
    logos?: Record<string, string>; // contains url to image for every efficiencyClass value
};

export type EcoLabelPopupLabelType = {
    letter: string;
    color?: string;
    label?: string;
};

export type EcoLabelPopupSettingsType = {
    title: string;
    moreInfoLinkLabel: string;
    readMoreLink: string;
    thumbnailsCount: number;
    labels: EcoLabelPopupLabelType[];
};

export type AEMBannerDescriptionItemType = {
    label: string;
    disclaimer?: string;
};

export type LegalBannerDisclaimerSettingsType = {
    title?: string;
    // Image in Banner Title
    image?: {
        mobile?: {
            imagePath?: string;
            altText?: string;
        };
        desktop?: {
            imagePath?: string;
            altText?: string;
        };
    };
    // Table Headers
    finance?: Record<string, string>;
};

// test and PRODUCTION are the only valid values
export type FinanceCalculatorEnvironmentType = "test" | "PRODUCTION" | undefined;
